module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/assessment_achievements/6_97f6b94f7c75afffa549e971bb2f8b25.png";